// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { BenchmarkSelector } from '@shared/advisory/aggregation/components/benchmark-selector';
import { useAppSelector } from '@advisor-app/store/store';
import { selectSavedPortfoliosBenchmarks } from '@advisor-app/store/slices/my-research/my-research-selectors';
import { type FC } from 'react';
import type { BenchmarkSelectorProps } from '@shared/advisory/aggregation/components/benchmark-selector';

/**
 * Wrapper component for BenchmarkSelector that automatically injects saved
 * portfolios benchmarks from the Redux store. This is specific to citec-app.
 */
export const BenchmarkSelectorWrapper: FC<BenchmarkSelectorProps> = props => {
  const savedBenchmarks = useAppSelector(selectSavedPortfoliosBenchmarks);

  return <BenchmarkSelector {...props} savedBenchmarks={savedBenchmarks} />;
};
